"use strict";
var Observable_1 = require('../../Observable');
var distinct_1 = require('../../operator/distinct');
Observable_1.Observable.prototype.distinct = distinct_1.distinct;
//# sourceMappingURL=distinct.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/distinct.js
 ** module id = 181
 ** module chunks = 2
 **/